import {
  Beer,
  BottleWine,
  Citrus,
  Coffee,
  CupSoda,
  CupSoda as DefaultIcon,
  GlassWater,
  Martini,
  Wine,
  Zap,
} from 'lucide-react';

import {
  DRINKS_CONFIG,
  DRINKS_KEYWORDS,
  VALID_DRINKS_SUBCATEGORIES,
  detectDrinksSubcategory,
  detectDrinksSubcategoryWithConfidence,
} from '@splitfiesta/core';

export {
  DRINKS_CONFIG,
  DRINKS_KEYWORDS,
  VALID_DRINKS_SUBCATEGORIES,
  detectDrinksSubcategory,
  detectDrinksSubcategoryWithConfidence,
};

type DrinksIcon = React.ComponentType<{ className?: string }>;

export const DRINKS_SUBCATEGORY_ICONS: Record<string, DrinksIcon> = {
  drinks: CupSoda,
  water: GlassWater,
  juice: Citrus,
  soda: CupSoda,
  coffee: Coffee,
  tea: Coffee,
  energy: Zap,
  beer: Beer,
  wine: Wine,
  cocktails: Martini,
  spirits: BottleWine,
  alcohol: Wine,
  bar: Beer,
  default: DefaultIcon,
};

export function getDrinksIcon(
  subcategory: string | null | undefined
): DrinksIcon {
  if (!subcategory || !(subcategory in DRINKS_SUBCATEGORY_ICONS)) {
    return DRINKS_SUBCATEGORY_ICONS.default;
  }
  return DRINKS_SUBCATEGORY_ICONS[subcategory];
}
